export default __webpack_public_path__ + "static/media/banner_autoconsum.21e30e5a.png";